// extracted by mini-css-extract-plugin
module.exports = {"container":"DataGrid_container__oVmGb"};